import React from "react"
export function FlightTransfer(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__flight-transfer"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M5.304 13.243L7.02 11.53l-1.06-1.057-2.989 2.98a.746.746 0 000 1.057L5.97 17.5l1.06-1.057-1.71-1.705h6.649c.552 0 1-.447 1-.997v-1.993h-1.5v1.495H5.304zm9.394-5.982L12.985 8.97l1.06 1.057 2.988-2.98a.746.746 0 000-1.057L14.035 3l-1.06 1.057 1.715 1.71H7.983c-.552 0-1 .446-1 .996v1.99h1.5V7.26h6.215z"
          id="prefix__transfer"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
